module.exports = __webpack_public_path__ + "static/media/new-nav-search-icon.433a1476.svg";